import { httpMethod } from "../../../enum/httpMethod";
import { apiRequest, API_SUCCESS, API_ERROR } from "../../actions/api.action";
import { setLoader } from "../../actions/ui.action";
import { setNotification } from "../../actions/notification.action";
import {
  LANGUAGE,
  SET_LANGUAGE,
  getDictionary,
  GET_DICTIONARY,
  DICTIONARY,
  setDictionary,
  GET_LANGUAGES,
  GET_LANGUAGE,
  setResult,
} from "../../actions/language.action";
import { TypeOfMessage } from "../../store/base/notify";

const _URL = process.env.LANGUAGE_URL as string;

export const languageMiddleware = (store: any) => (next: any) => (
  action: any
) => {
  next(action);

  switch (action.type) {
    case SET_LANGUAGE:
      store.dispatch(getDictionary(action.payload));
      next([setLoader(true, LANGUAGE)]);
      break;

    case GET_LANGUAGE:
      next([
        apiRequest(
          action.payload,
          httpMethod.GET,
          `${_URL}/index.json`,
          GET_LANGUAGE
        ),
        setLoader(true, LANGUAGE),
      ]);
      break;

    case GET_LANGUAGES:
      next([
        apiRequest(null, httpMethod.GET, `${_URL}/index.json`, GET_LANGUAGES),
        setLoader(true, LANGUAGE),
      ]);
      break;

    case GET_DICTIONARY:
      next([
        apiRequest(
          action.payload,
          httpMethod.GET,
          `${_URL}/${action.payload}.json`,
          GET_DICTIONARY
        ),
        setLoader(true, DICTIONARY),
      ]);
      break;

    case `${LANGUAGE} ${API_SUCCESS}`:
      // console.log(action);
      store.destpach(setResult(action.payload, action.meta));
      next([setLoader(false, DICTIONARY)]);
      break;

    case `${DICTIONARY} ${API_SUCCESS}`:
      next([setDictionary(action.payload), setLoader(false, DICTIONARY)]);
      break;

    case `${DICTIONARY} ${API_ERROR}`:
    case `${LANGUAGE} ${API_ERROR}`:
      let message = {
        info: " عفواً اعد محاولة مرة اخرى...! \n !...Sorry, try again",
        type: TypeOfMessage.danger,
      };
      next([
        setNotification(message, DICTIONARY),
        setLoader(false, DICTIONARY),
      ]);
      break;
  }
};
